<template>
  <section class="d-grid gap-4">
    <header>
      <h2 class="h4 mb-1">Ecommerce</h2>
      <p class="text-muted mb-0">
        Configuración del storefront público, mensajes al cliente y catálogo online.
      </p>
    </header>

    <div class="row g-3">
      <div v-if="canManageEcommerce" class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Configuración</h3>
            <p class="text-muted small mb-3">Número de WhatsApp, modo de entrega, marca y colores del storefront.</p>
            <router-link class="btn btn-dark btn-sm" :to="{ name: 'EcommerceConfiguracion' }">Abrir</router-link>
          </div>
        </div>
      </div>
      <div v-if="canManageEcommerce" class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Mensajes y avisos</h3>
            <p class="text-muted small mb-3">Textos de WhatsApp para resumen de compra, retiro y envío, y los tiempos de entrega.</p>
            <router-link class="btn btn-dark btn-sm" :to="{ name: 'EcommerceMensajes' }">Abrir</router-link>
          </div>
        </div>
      </div>
      <div v-if="canManageImages" class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Catálogo e imágenes</h3>
            <p class="text-muted small mb-3">Auditoría y backfill de imágenes de producto, y re-descarga de fotos.</p>
            <router-link class="btn btn-dark btn-sm" :to="{ name: 'EcommerceImagenes' }">Abrir</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { hasPermission } from '@/services/authSessionService'

const canManageEcommerce = computed(() => hasPermission('gestionar_ecommerce'))
const canManageImages = computed(() => hasPermission('editar_productos'))
</script>
